import React, { useMemo, useState } from 'react';
import { LayoutRectangle, View, ViewProps } from 'react-native';
import useStyles, { GAP } from './CardGrid.styles';

export type CardProps = ViewProps & {
  /**
   * Height depends on the size:
   * s - 92%
   * m - 62%
   * l - 30%
   */
  size?: 's' | 'm' | 'l';
};

export const CardGrid: React.FC<CardProps> = ({ children, size = 's', style, ...props }) => {
  const [dimensions, setDimensions] = useState<LayoutRectangle>();
  const s = useStyles();

  const width = useMemo(() => {
    if (!dimensions?.width) {
      return 0;
    }

    switch (size) {
      case 's':
        return (dimensions.width - GAP * 2) / 3;
      case 'm':
        return (dimensions.width - GAP) / 2;
      case 'l':
        return dimensions.width;
    }
  }, [dimensions, size]);

  const height = useMemo(() => {
    if (width === 0) {
      return 0;
    }

    switch (size) {
      case 's':
        return width * 0.92;
      case 'm':
        return width * 0.62;
      case 'l':
        return width * 0.3;
    }
  }, [size, width]);

  const cardsCount = React.Children.count(children);

  return (
    <View
      style={[s.root, style, { height }]}
      {...props}
      onLayout={event => setDimensions(event.nativeEvent.layout)}
    >
      {React.Children.map<any, any>(children, (child, i) =>
        React.cloneElement(child, {
          style: [child.props.style, i !== cardsCount - 1 && s.gap, { width }],
        })
      )}
    </View>
  );
};
